import { productToLayoutMap } from './scenesMapConfig';
import { PreviewLayoutConfig } from './types';
import { useProductContext } from '../../hooks/ProductContextHooks';

export const useBookletPreviews = () => {
  // Placeholder for future logic related to booklet previews
  const {
    productInformation: { productKey },
  } = useProductContext();
  const bookletPreviewLayout: PreviewLayoutConfig = productToLayoutMap[productKey];
  const isBookletPreviewAvailable = !!bookletPreviewLayout;
  return { isBookletPreviewAvailable, bookletPreviewLayout };
};
